import { render, staticRenderFns } from "./MatsListing.vue?vue&type=template&id=7885573e&scoped=true"
import script from "./MatsListing.vue?vue&type=script&lang=js"
export * from "./MatsListing.vue?vue&type=script&lang=js"
import style0 from "./MatsListing.vue?vue&type=style&index=0&id=7885573e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7885573e",
  null
  
)

export default component.exports